import type { AppRole } from './database.types';

export const ROLE_LABELS: Record<AppRole, string> = {
  admin: 'Administrador',
  gestor: 'Gestor / PMO',
  editor: 'Editor',
  viewer: 'Leitor',
};

/** Contexto de permissão do usuário na organização atual. */
export interface Grants {
  role: AppRole;
  areaKeys: string[]; // áreas às quais o usuário pertence
}

export function isAdmin(g: Grants): boolean {
  return g.role === 'admin';
}
export function isAdminOrGestor(g: Grants): boolean {
  return g.role === 'admin' || g.role === 'gestor';
}
export function canManageProducts(g: Grants): boolean {
  return isAdminOrGestor(g);
}

/**
 * Áreas que — além de admin/gestor — podem ABRIR novos projetos.
 * "Diretoria" corresponde à área 'ceo' (CEO / Diretoria).
 */
export const PRODUCT_CREATOR_AREAS = ['marketing', 'pd', 'ceo', 'qualidade'];

/**
 * Pode criar um novo projeto? admin/gestor sempre; editores de Marketing, P&D,
 * Qualidade ou Diretoria também. (O RLS do banco espelha isto — ver 0016.)
 * Editar/cancelar projetos existentes continua restrito a admin/gestor
 * (canManageProducts).
 */
export function canCreateProducts(g: Grants): boolean {
  if (isAdminOrGestor(g)) return true;
  if (g.role === 'editor') return PRODUCT_CREATOR_AREAS.some((k) => g.areaKeys.includes(k));
  return false;
}
export function canManageUsers(g: Grants): boolean {
  return isAdmin(g);
}

/**
 * Áreas que — além de admin/gestor — preenchem a Rampa de lançamentos.
 * Marketing e Comercial (vendas). (Espelha o RLS da 0026.)
 */
export const RAMP_FILLER_AREAS = ['marketing', 'vendas'];
export function canFillRamps(g: Grants): boolean {
  if (isAdminOrGestor(g)) return true;
  if (g.role === 'editor') return RAMP_FILLER_AREAS.some((k) => g.areaKeys.includes(k));
  return false;
}

/**
 * Pode editar a etapa cujas áreas responsáveis são `stageAreaKeys`?
 * admin/gestor sempre; editor apenas se pertencer a alguma dessas áreas;
 * leitor nunca. (Espelha a função can_edit_stage do banco — o RLS é a
 * autorização real; isto só reflete o mesmo no front, p/ desabilitar campos.)
 */
export function canEditStage(g: Grants, stageAreaKeys: string[]): boolean {
  if (isAdminOrGestor(g)) return true;
  if (g.role !== 'editor') return false;
  return stageAreaKeys.some((k) => g.areaKeys.includes(k));
}

export function canEditCards(g: Grants): boolean {
  return g.role !== 'viewer';
}
